@if(contextualMessages.length > 0){
  <div class="sx-system-message__contextual-container sxl-flex sxl-column" [ngClass]="cssClass">
    <app-contextual-system-message [contextualMessages]="contextualMessages"></app-contextual-system-message>
  </div>
}
